import React from "react";
import ReactGA from "react-ga4";
import { Typography, Button } from "design_system/src";
import { Link } from "react-router-dom";
import VideoAnimation from "./VideoAnimation";


const FinancialInclusion: React.FC = () => {
  const handleFaqsButton = () => {
    ReactGA.event("CTA_Home_go_to_faqs", {
      category: "Home",
      label: "click in CTA to go to FAQs",
    });
  };

  return (
    <section className="dso_container p_y_md">
      <Typography
        scale="heading1"
        scaleMobile="heading3"
        weight="600"
        component="h2"
      >
        Impulsamos la inclusión <br />financiera y laboral
      </Typography>

      <div className="display_flex flex_col_reverse_mobile flex_gap_md">
        <div className="w_50_per_desktop">
          <VideoAnimation>
            <iframe
              width="100%"
              height="100%"
              className="br_sm"
              src="https://www.youtube.com/embed/8vRmwBTAvGc?si=VNJ11duNkVCNn6PS"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            />
          </VideoAnimation>
        </div>

        <div className="w_50_per_desktop">
          <Typography
            scale="heading4"
            scaleMobile="large"
            weight="400"
            className="m_b_md"
          >
            <strong>¿Sin historial crediticio?</strong> En <strong>Ozon</strong> no se requiere historial crediticio para financiar una moto. Puedes solicitar tu financiamiento sin ningún problema, nos caracterizamos por utilizar tecnología para alcanzar a clientes no bancarizados.
          </Typography>
          <Typography
            scale="heading4"
            scaleMobile="large"
            weight="400"
            className="m_b_lg"
          >
            Tienes dudas sobre el proceso, consulta en nuestra sección de preguntas frecuentes.
          </Typography>
          <Link to="/faqs">
            <Button onClick={handleFaqsButton} scale="small" className="w_100_per_mobile">
              <Typography
                scale="medium"
                weight="600"
              >
                Preguntas frecuentes
              </Typography>
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FinancialInclusion;
